import React from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { RolloverDashboardReport } from '../types';
import { PaperWrapper } from '../../common/styled';
import { dataGridSx } from '../../common/styled/DataGrid';
import pallet from '../../../layouts/pallet';
import tableColumnUtils from '../../../utils/tableColumnUtils';
import CustomDataGridToolbar from '../../common/components/CustomDataGridToolbar';

interface RolloverDataGridProps {
  reportData: RolloverDashboardReport[];
  columns: GridColDef[];
  loading: boolean;
  getGradeWiseSummary: boolean;
}

const RolloverDataGrid: React.FC<RolloverDataGridProps> = ({
  reportData,
  columns,
  loading,
  getGradeWiseSummary
}) => {
  return (
    <PaperWrapper>
      <DataGrid
        rowHeight={50}
        rows={reportData.map((row, index) => ({ ...row, id: index }))}
        columns={columns}
        loading={loading}
        disableRowSelectionOnClick
        pageSizeOptions={
          getGradeWiseSummary ? tableColumnUtils.PAGE_SIZE_OPTIONS : undefined
        }
        initialState={
          getGradeWiseSummary
            ? {
                ...tableColumnUtils.DATA_GRID_INITIAL_STATE,
                columns: {
                  columnVisibilityModel: {
                    grade: getGradeWiseSummary,
                    paidUsersPercentage: !getGradeWiseSummary
                  }
                }
              }
            : {
                columns: {
                  columnVisibilityModel: {
                    grade: false
                  }
                }
              }
        }
        showToolbar
        slots={{ toolbar: CustomDataGridToolbar }}
        slotProps={{
          toolbar: {
            printOptions: { disableToolbarButton: true },
            showQuickFilter: true
          }
        }}
        sx={{
          ...dataGridSx(pallet),
          '& .MuiDataGrid-virtualScroller': {
            overflowY: 'auto'
          }
        }}
      />
    </PaperWrapper>
  );
};

export default RolloverDataGrid;
